'use client'

import { CollectionContainer } from '@/components/common/collection/collection-container'
import { Button } from '@/components/ui/button'
import { ImageHelper } from '@/lib/helpers/image.helper'
import Image from 'next/image'
import Link from 'next/link'
import { FC } from 'react'

export const BirthdayAvatarFrame: FC = () => {
  return (
    <CollectionContainer className='bg-white pt-12 max-md:pb-0 md:pt-20 lg:pt-28'>
      <div className='flex flex-col items-center justify-between gap-6 md:flex-row 2xl:gap-16'>
        <div className='flex-1'>
          <h2 className='font-criteria text-3xl font-bold uppercase leading-tight text-neutral-900 md:text-4xl lg:text-[44px] lg:leading-normal'>
            THAY AVA HƯỞNG ỨNG <br className='max-md:hidden' /> SINH NHẬT
            COOLMATE
          </h2>
          <p className='my-2 text-lg leading-relaxed text-primary md:mb-6 md:text-xl'>
            Một chiếc khung xinh xắn dành tặng cho tất cả người đồng hành cùng
            Coolmate
          </p>
          <p className='mb-4 text-base leading-relaxed text-neutral-700 md:mb-11 md:text-lg'>
            Coolmate gửi tặng bạn Voucher 100K cho đơn 200K khi thay khung ảnh
            này!
          </p>
          <Link href='/avatar-frame'>
            <Button variant='primary' size='large'>
              THAY ẢNH NGAY THÔI!!
            </Button>
          </Link>
        </div>
        <div className='flex-1'>
          <Image
            src={ImageHelper.getImageUrl('/image/2026/03/25/image_1.jpg')}
            alt='Avatar Frame Preview'
            width={800}
            height={480}
            className='h-auto w-full rounded-2xl shadow-[0_20px_50px_rgba(8,112,184,0.1)]'
          />
        </div>
      </div>
    </CollectionContainer>
  )
}
